/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { useDispatch } from "react-redux";

import { FileArrowUpRegularV6 } from "@shared/v2/Icomoon";

import ActivityContainer from "./ActivityContainer";
import { activityCommonDefaultProps, activityCommonPropTypes, STYLES } from "../shared";
import Header from "./Header";
import CategoryContainer from "./CategoryContainer";
import DataField from "./DataField";
import { useTheme } from "../../../../reducers/layoutReducer/selectors";
import ActivityBtns from "./shared/ActivityBtns";
import { setCallParams } from "../../../../reducers/dialerReducer/dialerReducer";

const getFormName = (activity) => {
  switch (activity.notificationType) {
    case "adjusted_equity_calculator":
      return "Home Value - Adjusted Equity Calculator";
    case "cash_offer_submitted":
      return "Home Value - Cash Offer Submitted";
    case "cma_requested":
      return "Home Value - CMA Requested";
    case "home_value_submitted":
      return "Home Value - CMA Requested";
    case "sell_my_home_submitted":
      return "Sell My Home";
    case "unlock_equity_requested":
      return "Home Value - Unlock Equity";
    case "valuation_requested":
      return "Home Value - Get Professional Valuation";
    case "contact_form_general":
      return "Contact Form";
    case "get_prequalified":
      return "Market Report - Get Pre-Qualified";
    case "prequalification_request":
      return "Get Pre-Qualified";
    case "feedback_submitted":
      return "Home Value - Feedback";
    case "contact_form_ask_a_question":
      return "Market Report - Asked a Question";
    case "contact_us":
      return "Market Report - Contact Form";
    case "sell_my_home_submitted_market_report":
      return "Market Report - Sell My Home";
    default:
      return "Unknown";
  }
};

const SubmittedFormActivity = ({ activity, onReadChange }) => {
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams();
  queryParams.set("tab", "3");

  const isPlace = useTheme()?.name === "place-theme";

  const content =
    activity.notificationType === "contact_form_ask_a_question" ? activity.data?.question : activity.content;

  const viewReportUrl = activity.data?.marketReportUrl || activity.data?.reportUrl;

  return (
    <ActivityContainer activity={activity} queryParams={queryParams.toString()} onReadChange={onReadChange}>
      <Header
        category={
          <CategoryContainer containerClassName={STYLES.badgeThemed(isPlace)} Icon={FileArrowUpRegularV6}>
            Submitted Form
          </CategoryContainer>
        }
        personName={`${activity.data?.subjectFirstName} ${activity.data?.subjectLastName}`}
        time={activity.createdAt}
        onReadChange={onReadChange}
        loading={activity.loading}
        read={activity.read}
      />
      <div className={`${STYLES.contentContainer} tw-text-14d`}>
        <DataField label="Form Name" data={getFormName(activity)} />
        <DataField label="Content" data={content} />
        <ActivityBtns
          callHandlr={() => {
            if (activity?.personUuid) {
              dispatch(
                setCallParams({ leadUuids: [activity.personUuid], callSource: "Submitted Form Activity" }),
              );
            }
          }}
          reportHandlr={
            viewReportUrl
              ? () => {
                  window.open(viewReportUrl, "_blank");
                }
              : null
          }
        />
      </div>
    </ActivityContainer>
  );
};

export default SubmittedFormActivity;

SubmittedFormActivity.propTypes = {
  ...activityCommonPropTypes,
};

SubmittedFormActivity.defaultProps = {
  ...activityCommonDefaultProps,
};
